export const colors = {
  borders: {
    faded: '#ccc',
  },
  font: {
    placeholder: '#ccc',
  },
}
